import { Component, HostListener, OnInit } from "@angular/core";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { QubesUser } from "src/app/pages/home/user-management-qubes/model/qubes-user";
import { timer } from "rxjs";
import { environment } from "src/environments/environment";
import { error } from "console";
@Component({
  selector: "auth-login",
  templateUrl: "./auth-login.component.html",
  styleUrls: ["./auth-login.component.scss"],
})
export class AuthLoginComponent implements OnInit {

  public eventData: any;
  userNamelogout: any;
  passwordlogout: any;
  subscribeTimers: number;

  subscribeTimersLogout: number = 0;
  abc: any;
  singnref: any;

  @HostListener('window:message', ['$event'])
  onMessage(e) {
    // console.log("Check This  :",e)
    if (e?.data?.type === undefined) {
      // console.log('Host lIstener Check', e)
      sessionStorage.setItem('currentUser', e.data);

      // console.log("Check This  :", e)
      if (e?.data?.type === undefined) {
        // console.log('Host lIstener Check', e)
        sessionStorage.setItem('currentUser', e.data);

      }
      // if(e?.data?.type == null){
      //   console.log("Type check : ",e?.data?.type)
      //   this.eventData = e.data;
      // }
      // console.log("reciver Event : ",e);
      // console.log("Check the data is persitant : ", this.eventData);
      // if (e.origin == environment.uatAppUrl) {
      //   // console.log("Some event has been passed...")
      //   sessionStorage.setItem('currentUser', JSON.stringify(this.eventData));
      // }else if(e.origin == "http://localhost:4201"){
      //   console.log("Some event has ben passed... #################",this.eventData)
      //   sessionStorage.setItem('currentUser', this.eventData);
      // } 
      // else {
      //   return false;
      // }
    }
  }
  public errorFlag: boolean = false;

  public userName = "";
  public password = "";
  public intOrExt: string = 'Internal';
  user: QubesUser;
  subscribeTimer: number = 0;
  externalUserNotExistFlag: boolean;
  loginUsingPasswordButton: boolean;
  otpValidFlag: boolean = false;
  public logout: boolean = true;
  constructor(public authService: AuthService, private _router: Router) { }

  ngOnInit() {
    this.user = new QubesUser();
    this.errorFlag = false;


  }


  login() {
    // if (this.intOrExt == 'Internal') {


    // } else if (this.intOrExt == 'External') {
    let user: any;
    this.authService.validateOtp(this.userName, this.password).subscribe(x => {
      // console.log("Valid");
      // sessionStorage.setItem("currentUser", JSON.stringify(x));
      // this._router.navigate(["/loading"]);
      user = x;
      console.log("This User : ", x);
      this.authenticateUser(user);

    }, (error) => {
      if (user == null) {
        // console.log("Not valid");
        this.otpValidFlag = true;
        // this.loginUsingPassword()
        // console.log("User : ", user)
        return;
      }
    })



  }
  datas() {

    this.userNamelogout = '';
    this.passwordlogout = '';

    if (this.abc != undefined) {
      this.abc.unsubscribe();
    }
    this.subscribeTimer = 0;
    this.subscribeTimersLogout = 0;






  }
  
  testrefresh(){
    

    if (this.abc != undefined) {
      this.abc.unsubscribe();
    }
    this.subscribeTimer = 0;
    this.subscribeTimersLogout = 0;
    this.externalUserNotExistFlag = false;
    // this.singnref()
    // this.subscribeTimer ==0
    
    



  }
  logfreshdatas() {
    this.userNamelogout = '';
    this.passwordlogout = '';
    if (this.abc != undefined) {
      this.abc.unsubscribe();
    }
    this.subscribeTimer = 0;
    this.subscribeTimersLogout = 0;

  }
  logfreshsingn() {
    this.passwordlogout = '';
    // this.abc.unsubscribe();
    // this.subscribeTimer = 0;
    // this.subscribeTimersLogout =0;  

  }
  logins() {

    // let user: any;
    // this.authService.validateOtp(this.userName, this.password).subscribe(x => {

    //   user = x;
    //   console.log("This User : ", x);
    //   this.authenticateUser(user);

    // }, (error) => {
    //   if (user == null) {
    //     // console.log("Not valid");
    //     this.logout = true;
    //     // console.log("User : ", user)
    //     return;
    //   }
    // })

    this.logout = true;
    this.userNamelogout = '';
    this.passwordlogout = '';

    this.abc.unsubscribe();
    this.subscribeTimer = 0;
    this.subscribeTimersLogout = 0;

  }
  loginsback() {

    let user: any;
    this.authService.validateOtp(this.userNamelogout, this.passwordlogout).subscribe(x => {

      user = x;
      console.log("This User : ", x);
      this.authenticateUser(user);

    }, (error) => {
      if (user == null) {
        // console.log("Not valid");
        this.logout = true;
        // console.log("User : ", user)
        return;
      }
    })

  }

  logouts() {

    this.logout = false;


  }



  authenticateUser(x: any) {
    // } else {
    //   Swal.fire("", "Please select Internal or External", "info");
    // }
    // console.log("login...", this.userName, this.password);
    // this.authService.login(this.userName, this.password).subscribe(
    //   (x) => {
    // console.log("service login credentials..", x);
    this.user = x;
    //
    this.errorFlag = false;
    if (this.user != null) {
      console.log("User Exists");

      if (this.user.id > 0) {
        console.log("User id is greater tha 0");
        if (this.user.userDetails.length > 0) {
          console.log("userDetails :", this.user.userDetails);
          if (this.user.userDetails[0] != undefined) {
            if (
              this.user.userDetails[0].userGroupId != undefined &&
              this.user.userDetails[0].userGroupId > 0
            ) {
              sessionStorage.setItem("currentUser", JSON.stringify(x));

              if (this.user.userDetails[0].userGroupName == 'MOH Clinic Category' || this.user.userDetails[0].userGroupName == 'MOH State' || this.user.userDetails[0].userGroupName == 'MOH District' || this.user.userDetails[0].userGroupName == 'MOH Circle' || this.user.userDetails[0].userGroupName == 'MOH Clinic' || this.user.userDetails[0].userGroupName == 'Call Center') {
                setTimeout(() => {
                  this._router.navigate(["/loading"]);
                }, 2500);

              } else {
                this._router.navigate(["/auth/landing"]);
              }
              this.errorFlag = false;
              // sessionStorage.setItem("currentUser", JSON.stringify(x));

            } else {
              this.redirectToLogin();
            }
          } else {
            this.redirectToLogin();
          }
        } else {
          this.redirectToLogin();
        }
        sessionStorage.setItem("currentUser", JSON.stringify(x));
      }
    } else {
      this.errorFlag = true;
    }
    //
    //   },
    //   (error) => (this.errorFlag = true)
    // );
  }

  public redirectToLogin() {
    Swal.fire(
      "",
      "User Group not assigned! Please contact administrator!!!",
      "error"
    );
  }
  forgotPassword() {
    this._router.navigate(["/auth/reset-password"]);
  }

  sendOtp() {
    if (this.userName == '' || this.userName == null) {
      Swal.fire("", "Please enter Email address/ User ID", "error")
    }
    else {
      const source = timer(1000, 2000);
      const abc = source.subscribe(val => {
        if (val == 30) {
          abc.unsubscribe();
          this.subscribeTimer = 0;
        } else {
          this.subscribeTimer = 30 - val;
        }

      });

      // only for external clinic users ....
      // if (this.intOrExt == 'External') {

      this.authService.fetchByUserName(this.userName).subscribe((x: any) => {
        if (x == null) {

          Swal.fire("", "User name is not found", "error")

        } else {
          if (x?.userDetails[0]?.userGroups[0]?.isActive != 'Y') {
            Swal.fire("", "Your Group Is InActive Currently.", "info");
            return;
          } else if (x?.organisationId == 2){
            var regex = /^[\w-\._\+%]+@(thelipl.in|qms.com.my)/;
            if(this.userName.match(regex)){
              console.log('matches')
              this.authService.sendOtp(this.userName).subscribe(x => {
                // console.log("Otp Sent", x);
                
              })
            }else{
              Swal.fire("","Only @qms.com.my or @thelipl.in is allowed","info");
              this.userName = ''
              abc.unsubscribe();
              this.subscribeTimer = 0
              console.log('wrong user',x)
            }
          }

          else {
            console.log('correct user',x)
            this.authService.sendOtp(this.userName).subscribe(x => {
              // console.log("Otp Sent", x);

            }, (error) => {
              console.log('errorrr',error)
              if (error?.status == 200) {
                this.externalUserNotExistFlag = false
              }else if (error?.status == 400){
                this.loginUsingPasswordButton = true
                Swal.fire('OTP not sent successfully','Something went wrong','error')
                abc.unsubscribe();
                this.subscribeTimer = 0
              } else {
                this.externalUserNotExistFlag = true
                abc.unsubscribe();
                this.subscribeTimer = 0
              }
            })

          }
        }
      }, (error) => {
        if (error.status == 403) {
          Swal.fire("", error.error, "error")
          // this.testrefresh()
          
    if (abc != undefined) {
      abc.unsubscribe();
    }
    this.subscribeTimer = 0;
    this.subscribeTimersLogout = 0;
        }
       
      })


    }
  }
  sendOtplogout() {

    if (this.userNamelogout == '' || this.userNamelogout == null) {
      Swal.fire("", "Please enter Email address/ User ID", "error")
    }
    else {
      const source = timer(1000, 2000);
      this.abc = source.subscribe(val => {
        if (val == 30) {
          this.abc.unsubscribe();
          this.subscribeTimersLogout = 0;
        } else {
          this.subscribeTimersLogout = 30 - val;
        }

      });
      {

        {
          this.authService.sentOtpToMailForLogout(this.userNamelogout).subscribe(x => {
            // console.log("Otp Sent", x);

          }, (error) => {
            if (error?.status == 200) {
              this.externalUserNotExistFlag = false
            } else {
              this.externalUserNotExistFlag = true
              this.abc.unsubscribe();
              this.subscribeTimersLogout = 0
            }
          })

        }
      }

      (error) => {
        if (error.status == 403) {
          Swal.fire("", error.error, "error")

          
          
        }
      }
    }
  }

  sendOtpins() {
    if (this.userNamelogout == '' || this.userNamelogout == null) {
      Swal.fire("", "Please Enter User Name", "error")
    }
    else {

      // const source = timer(1000, 2000);
      // this.abc = source.subscribe(val => {
      //   if (val == 30) {
      //     this.abc.unsubscribe();
      //     this.subscribeTimersLogout = 0;
      //   } else {
      //     this.subscribeTimersLogout = 30 - val;

      //   }

      // });
      this.authService.validateOtpFromMailLogout(this.userNamelogout).subscribe((x: any) => {

        Swal.fire("", "Logged Out From All Devices", "error")
        this.logfreshdatas()
        this.logout = true;

      }, (error) => {
        if (error.status == 200) {
          Swal.fire("", "Logged Out From All Devices", "error")
          this.logfreshdatas()
          this.logout = true;


        }
        else if (error.status == 403) {
          Swal.fire("", error.error, "error")
          // Swal.fire("", "LogOut From All Devices", "error")



        }
        // (error) => {
        //   if (error.status == 403) {
        //     Swal.fire("", error.error, "error")
  
            
            
        //   }
        // }
      })

    }
  }
  loginUsingPassword(){
    let user: any;
    this.authService.login(this.userName, this.password).subscribe(x => {
      if(this.userName !== 'venkateshkumar@qms.com.my' && this.userName !== 'sekar.suppiah@qms.com.my' && this.userName !== 'pramodan@qms.com.my') {
        Swal.fire('', 'This user dont have privilege to login', 'warning');
        this.password = '';
        return;
      }else {
// this.authService.login(this.userName, this.password).subscribe(
    //   (x) => {
      user = x;
      console.log("This User : ", x);
      Swal.fire({
        title: "Are you sure?",
        text:
          "Mail process will not work, Kindly reinitiate once get back to the normal",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: "Ok",
        showConfirmButton: true,
        cancelButtonText: "Cancel",
      }).then((willDelete) => {
        if (willDelete.dismiss) {
          Swal.fire("", "Cancelled", "error");
          window.location.reload();
        } else {
          this.authenticateUser(user);
        }
      });
      
    }

    }, (error) => {
      console.log('error wrong password',error)
      if (error.error.status == 403){
        Swal.fire('','Incorrect Username/Password','error')
      }else if(user == null){
        this.logout = true;
      }
    })
  }
}


